module.exports = __webpack_public_path__ + "img/category-new-released.dd7b4435.png";